// Space, middle dot (U+00B7), space — the one brand separator used app-wide.
const BRAND = 'RAS Picks';
const BRAND_SUFFIX = ` · ${BRAND}`;

// Single source of truth for the document `<title>`. Appends ` · RAS Picks` so
// every tab/bookmark is branded — but only when the page's own title does not
// already carry the brand. Public/SEO titles like
// "Subscribe to RAS Picks | CBB, NFL & CFB" or
// "NFL Picks Results | RAS Verified Record 2021–Now" already say "RAS", so they
// pass through untouched (no double-branding). This is also what keeps the
// suffix idempotent: once appended, the title contains "RAS", so re-wrapping it
// (SSR then client, or across client navigations) is a no-op.
export function wrapPageTitle(title?: string | JSX.Element | JSX.Element[] | null): string {
  const base = typeof title === 'string' ? title.trim() : '';
  if (!base) {
    return BRAND;
  }
  if (/ras/i.test(base)) {
    return base;
  }
  return `${base}${BRAND_SUFFIX}`;
}

export function getPageTitle<C extends Vike.PageContext>(pageContext?: C): string {
  if (!pageContext) {
    return wrapPageTitle();
  }

  const config =
    ('data' in pageContext && pageContext.data?.title) ||
    ('config' in pageContext && pageContext.config?.title) ||
    undefined;

  if (typeof config === 'function') {
    return wrapPageTitle(config(pageContext));
  }

  return wrapPageTitle(config);
}
